import React, { useState, useEffect, useContext } from 'react';


import SimpleTable from '../../components/tables/simpleTable';
import { typeFormatter, paymentTypeFormatter } from '../../components/formatters/defFormatter';
import TrashModal from '../../components/modals/trashModal';
import RecoverModal from '../../components/modals/recoverModal';
import AddModal from '../../components/modals/addModal';
import EditModal from '../../components/modals/editModal';
import DeleteModal from '../../components/modals/deleteModal';

import SearchFilter from '../../components/filters/search';
import CustomButton from '../../components/buttons/customButton';
import IsActiveFilter from '../../components/filters/isActive';
import AddButton from '../../components/buttons/addButton';
import DataFilter from '../../components/filters/dataFilter';
import DatePicker from '../../components/filters/datePicker';
import { dateTableFormatter } from '../../dynamic/dateFormatter';
import { FaPlus } from "react-icons/fa";

import Loader from '../../components/loader/loader';
import { numberFormatter, totalFormatter } from '../../components/formatters/numberFormatter';
import { dateFormatter } from '../../dynamic/dateFormatter';
import { clientOrderColumnDefs } from '../../components/tables/columnDefs';
import toast from 'react-hot-toast';

import { Space, Input, Tag, Button, Tabs } from 'antd';


import Select from 'react-select';
import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcViewDetails, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiBarcodeReader } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";

import { DataContext } from '../../init/getData';






function TrainerTransaction(props) {

  let { } = props;


  const { userData,  api, refAccountTrainer, accountTrainerData } = useContext(DataContext);
  const userRole = userData.role;
  
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const createdBy = parseInt(userData.id);


  const table = 'transaction';
  const title = 'Trainer TransactionS';


  useEffect(() => {  
    const fetchData = async () => {    
      try {
        await refAccountTrainer();
        setIsLoading(false);
      } catch (error) {
        console.error('Error refreshing data Contact Support');
      }
    };
    fetchData();
  }, []);

  const trainerOptions = accountTrainerData.map(item => ({
    value: item.id,
    label: item.name,
  }));
  trainerOptions.push({ value: null, label: 'All Trainers' })



  const today = new Date().toISOString().split('T')[0];

  const [idRow, setIdRow] = useState([]);
  const [refreshTable, setRefreshTable] = useState(true);
  const [columnDefs, setColumnDefs] = useState([]);
  const [filter, setFilter] = useState({ search: '', isActive: 'true', trainerId: null,  type: 'payment', fromDate: today, toDate: today, accountType: "trainer", isTrainerTransaction: "true" });

  const [showAddModal, setShowAddModal] = useState(false);
  const [showTrashModal, setShowTrashModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showRecoverModal, setShowRecoverModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  const [transaction, setTransaction] = useState({});

  // idRow Change
  useEffect(() => {
    setTransaction(
      {
        createdBy: createdBy,
        trainerId: filter.trainerId,
        isOut: idRow?.isOut,
        usd: idRow?.usd || 0,
        type: 'payment',
      }
    )  
  }, [idRow, filter]);



  const addModal = () => {
    if (filter.trainerId) {
      setIdRow([]);
      resetForm();
      setShowAddModal(!showAddModal);
    } else {
      toast.error('Please Select a Tainer')
    }
  }



  const resetForm = () => {
    setTransaction({})
  }


  // Generic handler for input changes
  const handleInputChange = (e) => {
    let { name, value } = e.target;
    if (value === 'true' || value === 'false') {
      value = JSON.parse(value)
    }

     
   
    setTransaction((prevtransaction) => ({
      ...prevtransaction,
      [name]: value,
    }));
  };

  const handleSelectChange = (selectedOption, name) => {
    setTransaction((prevtransaction) => ({
      ...prevtransaction,
      [name]: selectedOption.value,

    }));
  };


  const refreshTableFunction = () => {
    setRefreshTable(!refreshTable)
  }

  const recoverModal = (e) => {
    if (!showRecoverModal) {
      setIdRow(e);
    }
    setShowRecoverModal(!showRecoverModal);
  }

  const trashModal = (e) => {
    if (!showTrashModal) {
      setIdRow(e);
    }
    setShowTrashModal(!showTrashModal);
  }

  const deleteModal = (e) => {
    if (!showDeleteModal) {
      setIdRow(e);
    }
    setShowDeleteModal(!showDeleteModal);
  }

  const editModal = (e) => {
    if (!showEditModal) {
      setIdRow(e);
    }
    setShowEditModal(!showEditModal);
  }

  //Excel Data
  const getExcelData =  (data) => {

    const transformedData = [];
    data.forEach(item => {
      
      const newItem = {
        id: item.id,
        account: item.account?.name,
      };
  
      transformedData.push(newItem);
    });
  
    return transformedData;
  };

  let newColumnDefs = [
    { title: 'createdAt', dataIndex: 'createdAt', render: dateTableFormatter, width: '15%' },
    { title: 'trainer', dataIndex: 'trainer', render: (account) => (account?.name), width: '15%' },
    { title: 'type', dataIndex: 'type', render: typeFormatter, width: '15%' },
    { title: 'price', dataIndex: 'usd' },
  ];

  useEffect(() => {

    if (filter.isActive == 'true') {
      newColumnDefs.push(  
        {
          title: 'Edt',
          width: '5%',
          render: (_, record) => (
            record.type !== 'membership' && (
            <FiEdit size={16} style={{ cursor: 'pointer', color: '#2E70A5' }} onClick={() => editModal(record)} />
            )
          ),
        },
        {
          title: 'Del',
          width: '5%',
          render: (_, record) => (
            record.type !== 'membership' && (
            <BiSolidTrash size={18} style={{ cursor: 'pointer', color: '#e6434f' }} onClick={() => deleteModal(record)} />
            )
          ),
        }
      );
    } else {
      newColumnDefs.push({
        title: 'Rec',
        width: '5%',
        render: (_, record) => (
          <FcUndo size={20} style={{ cursor: 'pointer' }} onClick={() => recoverModal(record)} />
        ),
      });
    }
    setColumnDefs(newColumnDefs);

  }, [filter.isActive]);


    const formView = (
        <div style={{ userSelect: 'none' }}>
    
    
          {/* in or out  */}
      <Row className="mb-3" style={{ marginTop: '2%' }}>

                <Form.Group as={Col}>
                  <Form.Label>Type</Form.Label>
                  <select className="form-control" id='isOut' name='isOut'
                    value={transaction.isOut}
                    onChange={handleInputChange}
                    required
                  >
                    <option value='false'>In</option>
                    <option value='true'>Out</option>
                  </select>
                </Form.Group>
                </Row>

                
                <Row className="mb-3" style={{ marginTop: '2%' }}>
            <Form.Group as={Col}>
              <Form.Label>USD:</Form.Label>
              <input type="text" name="usd" id="usd" className="form-control"
            value={transaction.usd}
            onChange={handleInputChange}></input>
            </Form.Group>
            </Row>

          
          
            <Row className="mb-3" style={{ marginTop: '2%' }}>
            <Form.Group as={Col}>
          <Form.Label>Details</Form.Label>
          <textarea className="form-control" name="details" id="details"
            value={transaction.details}
            onChange={handleInputChange}></textarea>
        </Form.Group>

                
          </Row>
    
    
    
    
    
        </div >);
    




    const modalFooter = (
        <div>
        </div>
      );
    
      const tableFooter = (
        <div style={{ display: 'flex', justifyContent: 'space-between', position: 'absolute', left: '50%', transform: 'translateX(-50%)' }}>
        <div>
      
        <span className='table-footer footer-green'>Total payment:   {numberFormatter(data?.summary?.totalPayments, 2)}</span>
      </div>
      </div>
      );
    
    
      return (
        <div className='card'>
    
          {isLoading &&
            <Loader />
          }
    
    
          {!isLoading &&
            <>
              <div>
    
                <SearchFilter setFilter={setFilter} />
                <DatePicker setFilter={setFilter} filter={filter} />
          
               
  
                <DataFilter selectedOption={trainerOptions?.find(option => option.value === filter.trainerId)} 
                 setFilter={setFilter} dataOptions={trainerOptions} filterBy={'trainerId'} placeHolder={'All Trainers'} />
              
            
                <AddButton addModal={addModal} />
    
              </div>
    
    
    
              <SimpleTable
                filter={filter}
                showAddModal={showAddModal}
                addModal={addModal}
                table={table}
                title={title}
                columnDefs={columnDefs}
                idRow={idRow}
                setIdRow={setIdRow}
                refreshTable={refreshTable}
                data={data}
                setData={setData}
                tableFooter={tableFooter}
                api={api}
                getExcelData={getExcelData}
              />
    
              <TrashModal
                showModal={showTrashModal}
                toggleModal={trashModal}
                idRow={idRow}
                table={table}
                title={title}
                refreshTable={refreshTableFunction}
                api={api}
                data={{ id: idRow.id }}
              />
    
              <RecoverModal
                showModal={showRecoverModal}
                toggleModal={recoverModal}
                idRow={idRow}
                table={table}
                title={title}
                refreshTable={refreshTableFunction}
                api={api}
              />
    
              <AddModal
                showModal={showAddModal}
                toggleModal={addModal}
                formView={formView}
                idRow={idRow}
                table={table}
                title={title}
                refreshTable={refreshTableFunction}
                size={'lg'}
                resetForm={resetForm}
                footer={modalFooter}
                api={api}
                data={{ transaction }}
              />
    
              <EditModal
                showModal={showEditModal}
                toggleModal={editModal}
                formView={formView}
                idRow={idRow}
                table={table}
                title={title}
                refreshTable={refreshTableFunction}
                size={'lg'}
                footer={modalFooter}
                api={api}
                data={{ id: idRow?.id, transaction }}
              />

              <DeleteModal
              showModal={showDeleteModal}
              toggleModal={deleteModal}
              idRow={idRow}
              table={table}
              title={title}
              refreshTable={refreshTableFunction}
              api={api}
              data={{ id: idRow?.id, transaction }}
            />

    
    
            </>
          }
    
        </div>
      )
    }
    
export default TrainerTransaction;
